// extracted by mini-css-extract-plugin
export var growableInput = "_a8-0";
export var tagContainer = "_a8-2";
export var textInput = "_a8-1";